<template>
  <div>
    <ValidationProvider
      :name="$t('labels.category')"
      :rules="'required'"
      v-slot="{ errors }"
    >
      <v-select
        :items="userCategories"
        :disabled="disabled"
        :label="$t('labels.category')"
        :error-messages="errors[0]"
        v-model="selected"
        :multiple="multiple"
        :item-text="item => item.Name === 'nonAKSA' ? 'AKSA/AKSET Dışı' : item.Name"
        item-value="Id"
        chips
        small-chips
        deletable-chips
        clearable
        class="category-select"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import GroupService from '../services/GroupService';

export default {
  name: "UserCategorySelect",
  methods: {
    async getAssignmentCategories(){
      await GroupService.getAssignmentCategories()
      .then(response => {
        const data = response?.data?.Result || [];

        if(data.length > 0){
          this.userCategories = data;

          // Eğer multiple ise ve parent tarafından değer verilmemişse
          // otomatik olarak "tümü" (tüm Id'ler) seçilsin
          const noExternalValue = this.value === null || (Array.isArray(this.value) && this.value.length === 0);
          if (this.multiple && noExternalValue) {
            this.selected = data.map(item => item.Id);
          }
        }
      })
    },
  },
  async mounted() {
    await this.getAssignmentCategories();
    this.selected = this.value;
  },
  data: () => {
    return {
      userCategories: [],
      selected: null,
    };
  },
  watch: {
    // parent prop değişirse iç seçim güncellensin
    value(newVal) {
      this.selected = newVal;
    },
    // iç seçim değiştiğinde parent'e bildir
    selected(newVal) {
      this.$emit("input", newVal || []);
    }
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>